import { useEffect, useState } from "react";
import Header from "../components/Header/Header";
import Timeline from "../components/Timeline/Timeline";
import { useTranslation } from 'react-i18next';
import { fetchFormations, fetchExperiences } from "../services/api";
import './Experiences.css';

function Experiences() {
  const { t } = useTranslation();
  const [formations, setFormations] = useState([]);
  const [experiencesPro, setExperiencesPro] = useState([]);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const [formationsData, experiencesData] = await Promise.all([fetchFormations(), fetchExperiences()]);
        if (mounted) {
          setFormations(formationsData || []);
          setExperiencesPro(experiencesData || []);
        }
      } catch (error) {
        console.error('Erreur lors du chargement des expériences', error);
      }
    };
    load();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div>
      <Header title={t('experiences.title')} />

      <nav className="experiences-nav" aria-label={t('experiences.title')}>
        <a href="#experiences-pro">{t('experiences.professional')}</a>
        <a href="#formations">{t('experiences.education')}</a>
      </nav>

      <section id="experiences-pro" className="experiences-section" aria-labelledby="experiences-pro-title">
        <h1 id="experiences-pro-title">{t('experiences.professional')}</h1>
        <Timeline experiences={experiencesPro} />
      </section>

      <section id="formations" className="experiences-section" aria-labelledby="formations-title">
        <h1 id="formations-title">{t('experiences.education')}</h1>
        <Timeline experiences={formations} />
      </section>
    </div>
  );
}

export default Experiences;
